export default __webpack_public_path__ + "static/media/006-spine.27dc3401.svg";